




















import { defineComponent } from "@vue/composition-api";
import { BlockingStatus } from "@/types";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "MessagesSystemNote",
  components: { BaseIcon },
  props: {
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
  },
});
